const formRestoreEquipment = {
  text: '¿De verdad quieres restaurar el equipo?',
  text2: 'Todos los Servicios y Acciones relacionados con ese equipo serán restaurados.',
  title: 'RESTAURAR EQUIPO',
  buttonText: 'RESTAURAR EQUIPOS ELIMINADOS',
};

export default formRestoreEquipment;